export default __webpack_public_path__ + "static/media/loading.31c67155.gif";